export const PHONE_MASK = '000-000-0000';
export enum ZIP_CODE_MASK {
  'USA' = '00000',
  'Canada' = 'AAA AAA'
}
